import { BankingInformation } from 'src/modules/shared/models/banking-information.model';

export class UpdateBankingInformation {
  static readonly type = '[Banking Information] Update';

  constructor(
    public bankingInformation: BankingInformation
  ) {}
}
